// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/Assets/Images/bgWallpaper.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.consent-page {
  /* height: 100vh;
    width: 100vw; */
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  overflow-y: scroll;
}

.consent-header {
  display: flex;
  align-items: center;
  background-color: var(--neutral-white);
  width: 100%;
  padding: 16px 20px;
  gap: 12px;
  color: var(--black);
  font-size: 20px;
  font-weight: 600;
}

.contnet-container-wrapper {
  padding: 24px 16px;
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.content-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 6px;
  border-radius: 16px;
  border: 0.5px solid var(--border-light);
  background-color: var(--neutral-white);
  box-shadow: 0px 2px 52px 0px rgba(0, 0, 0, 0.02);
}

.image-div {
  width: 226px;
  height: 107px;
  /* border-radius: 8px; */
  background-color: var(--light-neutral-2);
}

.consent-content-header {
  color: var(--almost-black);
  font-family: "Noto Sans";
  font-size: 20px;
  font-weight: 700;
  letter-spacing: 0.193px;
  font-feature-settings: "clig" off, "liga" off;
  line-height: 150%;
  margin-top: 16px;
}

.consent-content-subheader {
  color: var(--dark-neutral-2);
  font-size: 15px;
  font-weight: 400;
  line-height: 205%;
  letter-spacing: 0.193px;
  font-feature-settings: "clig" off, "liga" off;
  font-family: "Noto Sans";
}

.consent-content-grid-wrapper {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 16px 20px;
}

.divider {
  border-top: 0.5px solid var(--border-top-light);
  width: 100%;
}

.consent-content-bottom {
  border-radius: 12px;
  background: var(--light-neutral-2);
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 20px 28px;
}

.consent-data-ques {
  color: var(--black);
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.15px;
  text-transform: capitalize;
  font-family: "Noto Sans";
  font-feature-settings: "clig" off, "liga" off;
}

.consent-data-text {
  color: var(--dark-neutral-2);
  font-feature-settings: "clig" off, "liga" off;
  font-family: "Noto Sans";
  font-size: 14px;
  font-weight: 400;
}

.consesnt-input-container {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.consent-input-wrapper {
  padding: 16px;
  background-color: var(--neutral-white);
  border-radius: 16px;
  border: 1px solid rgba(0, 0, 0, 0.05);
  display: flex;
  gap: 16px;
  align-items: flex-start;
}

.consent-given {
  border-radius: 16px 16px 0px 0px;
  background-color: var(--green-3);
  border: 1px solid var(--green-2);
}

.custom-checkbox {
  width: 50px;
  height: 20px;
  accent-color: var(--green-1) !important;
}

.consent-input-text {
  font-size: 14px;
  font-weight: 400;
  line-height: 145%;
  color: var(--almost-black);
}

.consent-proceed-btn {
  width: 100%;
  border-radius: 8px;
  border: 0.843px solid var(--light-neutral-4);
  background-color: var(--primary-dark);
  display: flex;
  gap: 8px;
  padding: 12px 16px;
  justify-content: center;
  align-items: center;
  color: var(--neutral-white);
  font-size: 16px;
  font-weight: 400;
}
`, "",{"version":3,"sources":["webpack://./src/Core/Components/Device_readiness_Consent/Device_readiness_Consent.css"],"names":[],"mappings":"AAAA;EACE;mBACiB;EACjB,mDAAwD;EACxD,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sCAAsC;EACtC,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,uCAAuC;EACvC,sCAAsC;EACtC,gDAAgD;AAClD;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,wBAAwB;EACxB,wCAAwC;AAC1C;;AAEA;EACE,0BAA0B;EAC1B,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,6CAA6C;EAC7C,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,6CAA6C;EAC7C,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,+CAA+C;EAC/C,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kCAAkC;EAClC,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,0BAA0B;EAC1B,wBAAwB;EACxB,6CAA6C;AAC/C;;AAEA;EACE,4BAA4B;EAC5B,6CAA6C;EAC7C,wBAAwB;EACxB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,mBAAmB;EACnB,qCAAqC;EACrC,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;EAChC,gCAAgC;EAChC,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uCAAuC;AACzC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,4CAA4C;EAC5C,qCAAqC;EACrC,aAAa;EACb,QAAQ;EACR,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;AAClB","sourcesContent":[".consent-page {\n  /* height: 100vh;\n    width: 100vw; */\n  background: url(\"/public/Assets/Images/bgWallpaper.svg\");\n  overflow-y: scroll;\n}\n\n.consent-header {\n  display: flex;\n  align-items: center;\n  background-color: var(--neutral-white);\n  width: 100%;\n  padding: 16px 20px;\n  gap: 12px;\n  color: var(--black);\n  font-size: 20px;\n  font-weight: 600;\n}\n\n.contnet-container-wrapper {\n  padding: 24px 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n}\n\n.content-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 20px 6px;\n  border-radius: 16px;\n  border: 0.5px solid var(--border-light);\n  background-color: var(--neutral-white);\n  box-shadow: 0px 2px 52px 0px rgba(0, 0, 0, 0.02);\n}\n\n.image-div {\n  width: 226px;\n  height: 107px;\n  /* border-radius: 8px; */\n  background-color: var(--light-neutral-2);\n}\n\n.consent-content-header {\n  color: var(--almost-black);\n  font-family: \"Noto Sans\";\n  font-size: 20px;\n  font-weight: 700;\n  letter-spacing: 0.193px;\n  font-feature-settings: \"clig\" off, \"liga\" off;\n  line-height: 150%;\n  margin-top: 16px;\n}\n\n.consent-content-subheader {\n  color: var(--dark-neutral-2);\n  font-size: 15px;\n  font-weight: 400;\n  line-height: 205%;\n  letter-spacing: 0.193px;\n  font-feature-settings: \"clig\" off, \"liga\" off;\n  font-family: \"Noto Sans\";\n}\n\n.consent-content-grid-wrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  padding: 16px 20px;\n}\n\n.divider {\n  border-top: 0.5px solid var(--border-top-light);\n  width: 100%;\n}\n\n.consent-content-bottom {\n  border-radius: 12px;\n  background: var(--light-neutral-2);\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  padding: 20px 28px;\n}\n\n.consent-data-ques {\n  color: var(--black);\n  font-size: 14px;\n  font-weight: 500;\n  letter-spacing: 0.15px;\n  text-transform: capitalize;\n  font-family: \"Noto Sans\";\n  font-feature-settings: \"clig\" off, \"liga\" off;\n}\n\n.consent-data-text {\n  color: var(--dark-neutral-2);\n  font-feature-settings: \"clig\" off, \"liga\" off;\n  font-family: \"Noto Sans\";\n  font-size: 14px;\n  font-weight: 400;\n}\n\n.consesnt-input-container {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.consent-input-wrapper {\n  padding: 16px;\n  background-color: var(--neutral-white);\n  border-radius: 16px;\n  border: 1px solid rgba(0, 0, 0, 0.05);\n  display: flex;\n  gap: 16px;\n  align-items: flex-start;\n}\n\n.consent-given {\n  border-radius: 16px 16px 0px 0px;\n  background-color: var(--green-3);\n  border: 1px solid var(--green-2);\n}\n\n.custom-checkbox {\n  width: 50px;\n  height: 20px;\n  accent-color: var(--green-1) !important;\n}\n\n.consent-input-text {\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 145%;\n  color: var(--almost-black);\n}\n\n.consent-proceed-btn {\n  width: 100%;\n  border-radius: 8px;\n  border: 0.843px solid var(--light-neutral-4);\n  background-color: var(--primary-dark);\n  display: flex;\n  gap: 8px;\n  padding: 12px 16px;\n  justify-content: center;\n  align-items: center;\n  color: var(--neutral-white);\n  font-size: 16px;\n  font-weight: 400;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
